import React, { ChangeEvent, useState } from 'react';
import withFilter from '@catalogo/service-americanas-product/src/questions-and-answers/hoc/filter';
import { DropDown } from '../../atoms';
import { Select, Option } from './styled';
import { ISelectSort } from '../../../types';

export const SelectSortComponent = ({ onChangeNew }: ISelectSort) => {
  const [label, setLabel] = useState('mais úteis');

  const onChangeFunc = (e: unknown) => {
    setLabel((e as ChangeEvent).target.id);
    onChangeNew(e);
  };

  return (
    <DropDown label={label} oneClick>
      <Select>
        <Option onClick={onChangeFunc}>
          <input
            key="mais úteis"
            type="radio"
            id="mais-uteis"
            name="mais úteis"
            checked={label === 'mais úteis'}
            onChange={() => null}
            value="likes"
          />
          <label htmlFor="mais úteis" id="mais uteis">
            mais úteis
          </label>
        </Option>
        <Option onClick={onChangeFunc}>
          <input
            type="radio"
            id="mais-recentes"
            name="mais recentes"
            checked={label === 'mais recentes'}
            onChange={() => null}
            value="descending"
            key="mais recentes"
          />
          <label id="mais recentes">mais recentes</label>
        </Option>
        <Option onClick={onChangeFunc}>
          <input
            key="mais antigas"
            type="radio"
            id="mais-antigas"
            name="mais antigas"
            checked={label === 'mais antigas'}
            onChange={() => null}
            value="ascending"
          />
          <label htmlFor="mais antigas" id="mais antigas">
            mais antigas
          </label>
        </Option>
      </Select>
    </DropDown>
  );
};

const SelectSort = withFilter(SelectSortComponent);

export { SelectSort };
export default SelectSort;
